var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE7\x9B\xB4\xE6\x8E\xA5\xE7\xBB\x98\xE5\x88\xB6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 75",
    d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
    fill: "#2469EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 75 (Stroke)",
    d: "M12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    fill: "#2469EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 76 (Stroke)",
    d: "M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z",
    fill: "#2469EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 574 (Stroke)",
    d: "M12 0C12.5523 0 13 0.447715 13 1V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V1C11 0.447715 11.4477 0 12 0Z",
    fill: "#2469EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 575 (Stroke)",
    d: "M12 19C12.5523 19 13 19.4477 13 20V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V20C11 19.4477 11.4477 19 12 19Z",
    fill: "#2469EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 576 (Stroke)",
    d: "M24 12C24 12.5523 23.5523 13 23 13L20 13C19.4477 13 19 12.5523 19 12C19 11.4477 19.4477 11 20 11L23 11C23.5523 11 24 11.4477 24 12Z",
    fill: "#2469EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 577 (Stroke)",
    d: "M5 12C5 12.5523 4.55228 13 4 13L1 13C0.447715 13 -6.78525e-08 12.5523 -4.37114e-08 12C-1.95703e-08 11.4477 0.447715 11 1 11L4 11C4.55228 11 5 11.4477 5 12Z",
    fill: "#2469EF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectDraw);
export default __webpack_public_path__ + "static/media/direct-draw.f62f3144b711e2fe11663e42f348d21a.svg";
export { ForwardRef as ReactComponent };